<template>
  <div>
    <MainNavbar v-if="user != null && hasAccount" :options="navOptions" />
    <ClaimsNavbar v-else />
    <main class="p-4 flex justify-center max-w-screen-lg m-auto">
      <router-view />
    </main>
  </div>
</template>

<script>
import ClaimsNavbar from "@/claims/Navbar";
import MainNavbar from "@/Navbar.vue";

export default {
  components: { ClaimsNavbar, MainNavbar },
  computed: {
    user() {
      return this.$store.state.user;
    },
    hasAccount() {
      return this.$store.state.account != null;
    },
    navOptions() {
      const options = [
        {
          name: "Claims",
          route: "Claims/Landing",
        },
        {
          name: "Support",
          redirect: "mailto:support@getaddify.com",
        },
      ];
      return options;
    },
  },
  async mounted() {
    const user = this.$store.state.user;
    if (user != null) return;

    const allowedRoutes = ["Claims/Landing", "Claims/VehicleLookup"];
    const isAllowedRoute = allowedRoutes.includes(
      this.$router.currentRoute.value.name,
    );
    const hasAccountId = !!this.$store.state.claimForm?.accountId;
    const hasVehicleId = !!this.$store.state.claimForm?.vehicleId;
    if (!isAllowedRoute && !hasAccountId && !hasVehicleId) {
      this.$router.replace({ name: "Claims/Landing" });
    }
  },
};
</script>
